import React from 'react';
import {
  Box,
  Divider,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { CustomizedTypography } from '@components/Customized';
import { clsx, colorSet } from '@components/Provider';

export interface DetailViewInformationProps {
  projectName: string;
  description?: string;
  content: React.ReactNode;
  paddingTop?: number;
}

const DetailViewInformation = ({
  projectName,
  description,
  content,
  paddingTop
}: DetailViewInformationProps) => {
  const { root, divider } = useStyles();
  const matches = useMediaQuery(useTheme().breakpoints.down(900));

  return (
    <Box
      className={root}
      position={'relative'}
      width={matches ? '100%' : 344}
      maxWidth={matches ? undefined : 344}
      minWidth={matches ? undefined : 344}
      height={654}
      bgcolor={colorSet.gray000}
      paddingTop={paddingTop ? `${paddingTop}px` : undefined}
    >
      <Box marginTop={matches ? 2 : '44px'}>
        <CustomizedTypography variant={'subtitle1'} fontWeight={'500'}>
          {projectName}
        </CustomizedTypography>
      </Box>

      <Divider className={clsx(divider, 'title-divider')} />

      <Box display={'flex'} flexDirection={'column'} gridGap={8}>
        {content}
      </Box>

      {description && (
        <>
          <Divider className={divider} />
          <Box marginBottom={3}>
            <CustomizedTypography variant={'body2'} className="description">
              {description}
            </CustomizedTypography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default DetailViewInformation;

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    overflowY: 'auto',
    '& p,h6': {
      wordBreak: 'break-all'
    },
    '& > div': {
      padding: '0 24px'
    },
    '& .description': {
      whiteSpace: 'pre-line'
    },
    [theme.breakpoints.down(900)]: {
      '& > .MuiBox-root': {
        padding: '0 16px'
      }
    }
  },
  divider: {
    height: 1,
    margin: `16px 24px`,
    background: colorSet.gray200,
    [theme.breakpoints.down(900)]: {
      margin: 16
    },
    '&:not(.title-divider)': {
      [theme.breakpoints.down(900)]: {
        margin: `24px 0`,
        height: 16
      }
    },
    '&.footer-divider': {
      position: 'sticky',
      height: 10,
      width: '100%',
      [theme.breakpoints.down(900)]: {
        display: 'none'
      }
    }
  }
}));
